import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

import {ActivatedRoute, Router} from '@angular/router';
import {Feriado} from 'src/app/core/feriado';
import {ConfirmDialogComponent} from '../common/confirm-dialog/confirm-dialog.component';
import {FeriadoService} from './../../services/feriado/feriado.service';
import {Acesso} from 'src/app/core/acesso';
import {CarregarPerfil} from 'src/app/core/carregar-perfil';
import {DataUtilService} from "../../services/commons/data-util.service";
import {DataSimplesPipe} from "../../pipes/data-simples.pipe";

@Component({
    selector: 'app-feriado',
    templateUrl: './feriado.component.html',
    styleUrls: ['./feriado.component.css']
})
export class FeriadoComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    feriados: Feriado[];
    mostrarTabela: boolean = false;
    msg: string;

    descricao: string;
    data: Date;

    displayedColumns: string[] = ['descricao', 'data', 'acoes'];
    dataSource: MatTableDataSource<Feriado> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    constructor(
        private feriadoService: FeriadoService,
        private router: Router,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private dataUtilService: DataUtilService
    ) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.dataSource.paginator = this.paginator;
        this.getAll();
    }

    limpar() {
        this.mostrarTabela = false;
        this.dataSource.data = [];

        this.descricao = null;
        this.data = null;
    }

    consultar() {
        if (this.descricao || this.data) {
            this.feriadoService.getFilter(this.descricao, this.data?.getTime()).subscribe((listaFeriados: Feriado[]) => {
                if (!listaFeriados) {
                    this.mostrarTabela = false
                    this.msg = "Nenhum registro para a pesquisa selecionada"
                } else {
                    this.dataSource.data = listaFeriados ? listaFeriados : [];
                    this.mostrarTabela = true;
                }
            });
        } else {
            this.getAll();
        }
    }

    atualizar(feriado: Feriado) {
        this.router.navigate(['/feriado/cadastrar'], {queryParams: {id: feriado.id}});
    }

    deletar(feriado: Feriado) {
        this.chamaCaixaDialogo(feriado);
    }

    private formatarData(data: Date): string {
        return DataSimplesPipe.prototype.transform(data);
    }
    chamaCaixaDialogo(feriado: Feriado) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Certeza que deseja excluir o feriado ${this.formatarData(feriado.data)} - ${feriado.descricao}?`,
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(confirma => {
                if (confirma) {

                    this.feriadoService.excluir(feriado.id).subscribe(() => {
                        this.consultar();
                    })

                } else {
                    dialogRef.close();
                }
            }
        );
    }

    getAll() {
        this.feriadoService.getAll().subscribe((feriados: Feriado[]) => {
            this.feriados = feriados
            this.dataSource.data = feriados ? feriados : [];
            this.verificaMostrarTabela(feriados);
        })

    }

    verificaMostrarTabela(feriados: Feriado[]) {
        if (!feriados || feriados.length == 0) {
            this.mostrarTabela = false;
            this.msg = "Nenhuma feriado cadastrado."
        } else {
            this.mostrarTabela = true;
        }
    }

    onMascaraDataInput(event) {
        return this.dataUtilService.onMascaraDataInput(event);
    }

}

